// extracted by mini-css-extract-plugin
export var card = "_9k-0";
export var expandedCard = "_9k-2";
export var paginated = "_9k-1";